<div *ngIf="show" class="{{ addPadding ? 'pt-3 pb-3' : ''}}">
  <span [ngStyle]="styles" class="status-no-data"><i class="fa fa-exclamation-triangle"></i>&nbsp;{{text}}</span>
</div>
